<template lang="html">
    <d-list-group flush>
      <d-list-group-item class="p-0">
        <d-form @submit.prevent="submit()">
          <d-form-row>

            <!-- Tempo de Garantia Default -->
            <d-col md="3" class="form-group">
              <label for="feWarrantyDefault">{{ $t('settings.settings.form.warranty.label') }}</label>
              <d-form-input
                id="feWarrantyDefault"
                v-model="model.warranty"
                :placeholder="$t('settings.settings.form.warranty.placeholder')"
              />
            </d-col>

            <!-- Tempo Alerta -->
            <d-col md="3" class="form-group">
              <label for="feTempoAlerta">{{ $t('settings.settings.form.timeAlert.label') }}</label>
              <d-form-input
                type="number"
                id="feTempoAlerta"
                :placeholder="$t('settings.settings.form.timeAlert.placeholder')"
                v-model="model.timeAlert"
              />
            </d-col>

          </d-form-row>

          <d-form-row>
            <d-col md="3" class="form-group">
              <label for="feLogo">{{ $t('settings.settings.form.logo.label') }}</label>
              <div class="custom-file mb-3">
                <input type="file" class="custom-file-input" id="feLogo" ref="file" @change="choseFile()"/>
                <label class="custom-file-label" for="feLogo">{{ file.name }}</label>
              </div>
            </d-col>
          </d-form-row>

          <d-form-row>
            <d-button type="submit" class="btn-primary">{{ $t('shared.actions.save') }}</d-button>
          </d-form-row>
        </d-form>

      </d-list-group-item>
    </d-list-group>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import SettingsService from '_services/rest/modules/settings';
import { _LOAD_MODEL_SETTING_, SETTINGS } from './SettingsModel';

export default {
  name: 'settings-form',
  components: {
  },
  data() {
    return {
      file: { name: '' },
      model: { ...SETTINGS },
    };
  },
  created() {
    this.file.name = this.$t('settings.settings.form.logo.chooseFile');
  },
  watch: {},
  methods: {
    ...mapActions([
      'activeAlert',
    ]),
    choseFile() {
      [this.file] = this.$refs.file.files;
      this.model.logo = this.file.name;
    },
    save() {
      SettingsService.saveOptions(this.model, 'settings')
        .then(() => this.activeAlert({
          message: this.$t('settings.alert.settingsSaved'),
          theme: 'success',
        }))
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        })
        .finally(this.loading = false);
    },
    submit() {
      this.loading = true;
      const { settings } = this.$store.state.settings;
      if (this.file.name !== settings.logo) {
        return this.uploadLogoFile();
      }
      return this.save();
    },
    uploadLogoFile() {
      SettingsService.upload(this.file)
        .then(response => {
          this.model.logo = response.path;
          this.file.name = this.model.logo;
          this.save();
        });
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_SETTING_, newValue => {
      this.model = { ...newValue };
      this.file.name = this.model.logo;
    });
  },
};
</script>

<style lang="scss" scoped>
.custom-file-label {
  overflow: hidden;
  white-space: nowrap;
}
</style>
